import generalTenant from '../../fields/cases/generalTenant';

export const QUERY_GET_GT_CASE = /* GraphQL */ `
	query($id: String!) {
		getGeneralTenantCase(id: $id) {
			${generalTenant}
		}
	}
`;
